export default __webpack_public_path__ + "static/media/vue.b004b9e7.png";